import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../store';
import { DetailsSharedActionPage, SharedActionPage } from '../../../store/details/shared/model';

import { Dispatch } from 'redux';
import { changePage } from '../../../store/details/shared/actions';
import { connect } from 'react-redux';
import styles from './side-nav.module.css';
import { getI18n } from '../../../store/utils/i18n/strings.manager';
import { Ii18n } from '../../../store/utils/contracts/i18n.interface';
import { Role } from '../../../store/shared/model';
import { previewAttachment } from '../../../store/details/expertise-attachment/actions';
import withParams from '../../common/withParams'
import { Params } from 'react-router-dom';

interface PropsFromState {
  readonly pages: DetailsSharedActionPage[];
  readonly currentPage: DetailsSharedActionPage;
  readonly roles: string[];
}

interface PropsFromDispatch {
  readonly changePage: typeof changePage;
  readonly previewAttachment: typeof previewAttachment;
}

// Higher-order component interface
interface WithParamsProps {
  params: Params<string>;
}

type AllProps = PropsFromDispatch & PropsFromState & ConnectedReduxProps & WithParamsProps;

class DetailsSideNav extends React.Component<AllProps> {
  private localization: Ii18n;
  private instructionId: number;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
    this.instructionId = Number(this.props.params.instructionId);
  }

  componentDidMount() {
    if (window.location.hash) {
      const page = this.props.pages
        .map(x => x.toLowerCase())
        .find(x => x === window.location.hash.split('#')[1].toLowerCase());

      if (page) {
        const pageRequest = new SharedActionPage();
        pageRequest.previousPage = this.props.currentPage;
        pageRequest.page = DetailsSharedActionPage[page.toUpperCase() as keyof typeof DetailsSharedActionPage];
        this.props.changePage(pageRequest);
      }
    }
  }

  componentDidUpdate(previousProps: AllProps) {
    if (previousProps.roles.length !== this.props.roles.length && this.props.roles.length > 0) {
      if (this.props.roles.includes(Role.CrInIn)) {
        // tslint:disable-next-line:no-non-null-assertion
        const selectedDetail = this.props.pages.find(x => x === this.props.currentPage)!;
        window.location.href = `#${selectedDetail.toLowerCase()}`;
      }
    }
  }

  renderPageContent = (page: DetailsSharedActionPage) => {
    return (<div id={page.toLowerCase()}
      onClick={() => {
        window.history.replaceState({}, '', `#${page.toLowerCase()}`);

        const pageRequest = new SharedActionPage();
        pageRequest.instructionId = this.instructionId;
        pageRequest.previousPage = this.props.currentPage;
        pageRequest.page = page; // DetailsSharedActionPage[page];
        this.props.changePage(pageRequest);

        if (page === DetailsSharedActionPage.EXPERTISE_ATTACHMENT) { this.props.previewAttachment(''); }
      }}
      className={page === DetailsSharedActionPage.OVERVIEW ? styles.pageItemOverview : styles.pageItem}
      key={page}>
      <img alt="" title={this.localization.get('sidebar.' + page.toLowerCase())} className={styles.pageItemImage} src={
        page === this.props.currentPage ? require(`../../../../../assets/images/${page.toLowerCase()}_85x85_sel.png`) : require(`../../../../../assets/images/${page.toLowerCase()}_85x85.png`)}></img>
      <div className={page === this.props.currentPage ? styles.pageItemSelected : ''}></div>
    </div>);
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.scrollableContent}>
          {this.props.pages.filter(x => x !== DetailsSharedActionPage.AGENDA).map(x => this.renderPageContent(x))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsShared }, shared }: ApplicationState): PropsFromState => ({
  pages: shared.roles.filter(r => r === Role.CrInIn).length > 0 ? detailsShared.pages : detailsShared.pages.filter(p => p !== DetailsSharedActionPage.HONORARY_NOTE),
  currentPage: detailsShared.currentPage,
  roles: shared.roles
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  changePage: (page: Partial<SharedActionPage>) => dispatch(changePage(page)),
  previewAttachment: (amazonId: string) => dispatch(previewAttachment(amazonId))
});

export default connect(mapStateToProps, mapDispatchToProps)(withParams(DetailsSideNav));
